import { httpUrl } from "./httpUrl";

let baseUrl = `${httpUrl.host}/gy-apartment`;
let baseUrl84 = `${httpUrl.host}/gy-apartment`;

let api = {
  //物资类目——分页
  getCategoryPage: `${baseUrl}/category/getPage`,

  //物资类目——添加
  addCategory: `${baseUrl}/category/add`,

  //物资类目——删除
  deleteCategoryByCodes: `${baseUrl}/category/deleteByCodes`,

  //物资类目——详情
  getCategoryByCode: `${baseUrl}/category/getByCode`,

  //物资类目——修改
  updateCategory: `${baseUrl}/category/update`,

  //物资类目——导入
  importCategory: `${baseUrl}/category/import`,

  //获取物资类目列表
  getCategoryList: `${baseUrl}/category/getList`,

  //入库管理——分页
  getStorePage: `${baseUrl}/store/getPage`,

  //入库管理——添加
  addStore: `${baseUrl}/store/add`,

  //入库管理——删除
  deleteStoreByCodes: `${baseUrl}/store/deleteByCodes`,

  //物资入库——导入
  importStore: `${baseUrl}/store/import`,

  //物资入库——导出
  exportStore: `${baseUrl}/store/export`,

  //入库管理——详情
  getStoreByCode: `${baseUrl}/store/getByCode`,

  //入库管理——修改
  updateStore: `${baseUrl}/store/update`,

  //物资领用——分页
  getApplyPage: `${baseUrl}/apply/getPage`,

  //物资领用——导出
  exportApply: `${baseUrl}/apply/export`,

  //物资领用——添加
  addApply: `${baseUrl}/apply/add`,

  //获取物资名称列表
  getMaterialsList: `${baseUrl}/statistic/getListForApply`,

  //物资领用——详情
  getApplyByCode: `${baseUrl}/apply/getByCode`,

  //物资领用——修改
  updateApply: `${baseUrl}/apply/update`,

  //库存统计——分页
  getStatisticPage: `${baseUrl}/statistic/getStatistic`,

  //库存统计——导出
  exportStatistic: `${baseUrl}/statistic/export`,

  //物资盘点报表——导出
  exportMaterialsStatisticReport: `${baseUrl}/materialsStatisticReport/export`,

  //物资盘点——分页
  getCountTaskPage: `${baseUrl}/countTask/getPage`,

  //物资盘点——添加
  addCountTask: `${baseUrl}/countTask/add`,

  //物资盘点——删除
  deleteCountTaskByCodes: `${baseUrl}/countTask/deleteByCodes`,

  //物资领用——详情
  getCountTaskByCode: `${baseUrl}/countTask/getByCode`,

  //物资领用——修改
  updateCountTask: `${baseUrl}/countTask/update`,

  //盘点列表——分页
  getCountListPage: `${baseUrl}/countList/getPage`,

  //盘点列表——导出
  exportCountList: `${baseUrl}/countList/export`,

  //盘点列表——详情
  getCountListByCode: `${baseUrl}/countList/getByCode`,

  //物资领用——修改
  updateCountList: `${baseUrl}/countList/update`,

  //盘点报表——分页
  getCountReportPage: `${baseUrl}/countReport/getPage`,

  //盘点报表——导出
  exportCountReport: `${baseUrl}/countReport/export`,

  //盘点报表——生成报表
  getCountReport: `${baseUrl}/countReport/getReport`,

  //配置管理——分页
  getPersonConfigPage: `${baseUrl}/personConfig/getPage`,

  //配置管理——添加
  addPersonConfig: `${baseUrl}/personConfig/add`,

  //配置管理——删除
  deletePersonConfigByCodes: `${baseUrl}/personConfig/deleteByCodes`,

  //配置管理——详情
  getPersonConfigByCode: `${baseUrl}/personConfig/getByCode`,

  //配置管理——修改
  updatePersonConfig: `${baseUrl}/personConfig/update`,

  //获取园区人员列表
  getResponsiblePersonList: `${baseUrl84}/otherConfig/person/getResponsiblePerson`,

  //物资管理——分页
  getManagerPage: `${baseUrl}/manager/getPage`,

  //物资管理——添加
  addManager: `${baseUrl}/manager/add`,

  //物资管理——详情
  getManagerByCode: `${baseUrl}/manager/getByCode`,

  //物资管理——修改
  updateManager: `${baseUrl}/manager/update`,

  //物资管理——导入
  importManager: `${baseUrl}/manager/import`,

  //物资管理——导出
  exportManager: `${baseUrl}/manager/export`,

  //物资管理——删除
  deleteManagerByCodes: `${baseUrl}/manager/deleteByCodes`,

  //获取园区人员列表
  getManagerList: `${baseUrl}/manager/getList`,

  //库存盘点——分页
  getMaterialsStatisticTaskPage: `${baseUrl}/materialsStatisticTask/getPage`,

  //库存盘点——添加
  addMaterialsStatisticTask: `${baseUrl}/materialsStatisticTask/add`,

  //库存盘点——详情
  getMaterialsStatisticTaskByCode: `${baseUrl}/materialsStatisticTask/getByCode`,

  //库存盘点——修改
  updateMaterialsStatisticTask: `${baseUrl}/materialsStatisticTask/update`,

  //库存盘点——删除
  deleteMaterialsStatisticTaskByCodes: `${baseUrl}/materialsStatisticTask/deleteByCodes`,

  // 库存盘点——生成报表
  generateReport: `${baseUrl}/materialsStatisticReport/generateReport`,

  // 领用盘点——生成报表
  generateCountReport: `${baseUrl}/countReport/getReport`,

  //库存盘点列表——分页
  getMaterialsStatisticListPage: `${baseUrl}/materialsStatisticList/getPage`,

  //库存盘点列表——详情
  getMaterialsStatisticListByCode: `${baseUrl}/materialsStatisticList/getByCode`,

  //库存盘点列表——修改
  updateMaterialsStatisticList: `${baseUrl}//materialsStatisticList/update`,

  //库存盘点报表——分页
  getMaterialsStatisticReportPage: `${baseUrl}/materialsStatisticReport/getPage`
};

export { api };



// WEBPACK FOOTER //
// ./src/view/api/Material.js